import React, { Component } from 'react';
import './CatButtons.css';

import Button from '../Button/Button';

class CatButtons extends Component {
  constructor() {
    super();
    this.state = {
      selected: [],
      isSelected: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ]
    }
  }

  _selectCat = (cat) => {
    console.log(cat + " has been selected");
    var newState = this.state.selected.concat([cat]);
    this.setState({ selected: newState });
    this.props.sort(newState);
  }

  _unselectCat = (cat) => {
    var newState = this.state.selected;
    var newIsSelected = this.state.isSelected;
    newState = newState.filter(item => item !== cat);
    this.setState({ selected: newState });
    console.log(cat + " has been removed");
    this.props.sort(newState);

    // set isSelect = false for that cat
    if(cat === 'mechanics')
      newIsSelected[0] = false;
    if(cat === 'fluid mechanics')
      newIsSelected[1] = false;
    if(cat === 'oscillations and waves')
      newIsSelected[2] = false;
    if(cat === 'thermodynamics')
      newIsSelected[3] = false;
    if(cat === 'electricity and magnetism')
      newIsSelected[4] = false;
    if(cat === 'optics')
      newIsSelected[5] = false;
    if(cat === 'modern physics')
      newIsSelected[6] = false;
    if(cat === 'astronomy')
      newIsSelected[7] = false;

    this.setState({ isSelected: newIsSelected });
  }

  componentWillMount() {
    var newIsSelected = [false, false, false, false, false, false, false, false];
    this.setState({ selected: this.props.selectedButtons });
    for (var i = 0, len = this.props.selectedButtons.length; i < len; i++) {
      if(this.props.selectedButtons[i] === 'mechanics')
        newIsSelected[0] = true
      if(this.props.selectedButtons[i] === 'fluid mechanics')
        newIsSelected[1] = true;
      if(this.props.selectedButtons[i] === 'oscillations and waves')
        newIsSelected[2] = true;
      if(this.props.selectedButtons[i] === 'thermodynamics')
        newIsSelected[3] = true;
      if(this.props.selectedButtons[i] === 'electricity and magnetism')
        newIsSelected[4] = true;
      if(this.props.selectedButtons[i] === 'optics')
        newIsSelected[5] = true;
      if(this.props.selectedButtons[i] === 'modern physics')
        newIsSelected[6] = true;
      if(this.props.selectedButtons[i] === 'astronomy')
        newIsSelected[7] = true;
    }
    this.setState({ isSelected: newIsSelected });
  }

  render() {
    return (
      <div className="catButtonContainer">
        <Button direc="top" name="Mechanics"
          select={this._selectCat}
          isSelected={this.state.isSelected[0]}
          unselect={this._unselectCat} />
        <Button name="Fluid Mechanics"
          select={this._selectCat}
          isSelected={this.state.isSelected[1]}
          unselect={this._unselectCat} />
        <Button name="Oscillations and Waves"
          select={this._selectCat}
          isSelected={this.state.isSelected[2]}
          unselect={this._unselectCat} />
        <Button name="Thermodynamics"
          select={this._selectCat}
          isSelected={this.state.isSelected[3]}
          unselect={this._unselectCat} />
        <Button name="Electricity and Magnetism"
          select={this._selectCat}
          isSelected={this.state.isSelected[4]}
          unselect={this._unselectCat} />
        <Button name="Optics"
          select={this._selectCat}
          isSelected={this.state.isSelected[5]}
          unselect={this._unselectCat} />
        <Button name="Modern Physics"
          select={this._selectCat}
          isSelected={this.state.isSelected[6]}
          unselect={this._unselectCat} />
        <Button direc="bottom" name="Astronomy"
          select={this._selectCat}
          isSelected={this.state.isSelected[7]}
          unselect={this._unselectCat} />
      </div>
    )
  }
}

export default CatButtons;



// WEBPACK FOOTER //
// ./src/components/CatButtons/CatButtons.js